import { Col, Row } from "react-bootstrap";
import ModalContainer, {
  ModelContainerProps,
} from "../../../../shared/oversight-core/ui-elements/modal-container/modal-container";

const SubmitForApprovalLoginModal = (props: ModelContainerProps) => {
  const { show, onClose, onConfirm } = props;

  return (
    <ModalContainer
      show={show}
      onClose={onClose}
      onCancel={onClose}
      onConfirm={onConfirm}
      confirmButtonText="Login & Submit"
      title={"Submit estimation for expert approval"}
    >
      <Row>
        <Col className="text-color-2">
          Login and submit the estimation for expert approval? To submit your
          estimation for expert approval you must be logged in to the system.
        </Col>
      </Row>
    </ModalContainer>
  );
};

export default SubmitForApprovalLoginModal;
